import { Backdrop, List, ListItem, ListItemText, Collapse, Chip } from '@mui/material/';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import IndeterminateCheckBoxRoundedIcon from '@mui/icons-material/IndeterminateCheckBoxRounded';
import Styles from './CourseLogs.module.scss';
import { useState } from 'react';


export default function CourseLogs({ courseLogs, setCourseLogs }) {

    const [openLogStates, setOpenLogStates] = useState(Array(courseLogs.length).fill(false));

    const handleItemClick = (index) => {
        const newOpenStates = [...openLogStates];
        newOpenStates[index] = !newOpenStates[index];
        setOpenLogStates(newOpenStates);
    };
    const getChipColor = (action) => {
        switch (action) {
            case 'created':
                return 'success';
            case 'updated':
                return 'primary';
            case 'deleted':
                return 'error';
            case 'added':
                return 'success';
            case 'archived':
            case 'published':
                return 'warning'
            default:
                return 'primary';
        }
    }

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={courseLogs?.length !== 0}
            onClick={() => { setCourseLogs([]) }}
        >
            <div
                id="logsContainer"
                className={Styles.logsContainer}
                style={{ marginTop: '1em', fontFamily: 'monospace' }}
                onClick={e => e.stopPropagation()}
            >
                <div
                    id="logsTitleContainer"
                    style={{
                        display: 'flex',
                        width: '100%',
                        justifySelf: 'flex-start',
                        fontSize: '1.2em',
                        fontWeight: '600',
                        paddingBottom: '0.5em'
                    }}
                >
                    Course Logs:
                </div>
                {courseLogs.length >= 1 ? (
                    <List>
                        {courseLogs?.map((item, index) => (
                            <>
                                <span onClick={() => handleItemClick(index)}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-around',
                                        alignItems: 'center',
                                        cursor: (item.log_details?.length > 0) ? 'pointer' : 'auto'
                                    }}
                                >
                                    <Chip label={item.action} color={getChipColor(item.action)} sx={{ minWidth: '80px' }} variant="outlined" />
                                    <ListItem>
                                        <ListItemText
                                            primary={`[${item.modified_date}] - ${item.resource_type} "${item.resource_name}" was ${item.action} by ${item.username}`}
                                            primaryTypographyProps={{
                                                fontFamily: '"Ubuntu Mono", monospace',
                                                fontSize: '1em'
                                            }}
                                        />
                                    </ListItem>
                                    {item.log_details?.length > 0 &&
                                        <>
                                            {(openLogStates[index]) ? (
                                                <IndeterminateCheckBoxRoundedIcon fontSize='small' />
                                            ) : (
                                                <AddBoxRoundedIcon fontSize='small' />
                                            )}
                                        </>
                                    }
                                </span>
                                <Collapse in={(openLogStates[index] && item.log_details?.length > 0)}>
                                    <LogDetails logDetails={item.log_details} />
                                </Collapse>

                            </>
                        ))}
                    </List >
                ) : (
                    <div>No Logs to Display</div>
                )}
            </div>
        </Backdrop >
    )
}

const LogDetails = ({ logDetails }) => {
    return (
        <div
            style={{
                paddingLeft: '2%',
                borderRadius: '0.3em',
                backgroundColor: '#ececec'
            }}
        >
            {logDetails?.length > 0 ? (
                <>
                    {logDetails?.map((item) => (
                        <DetailItem label={item.field} oldValue={item.old_value} newValue={item.new_value} />
                    ))}
                </>
            ) : (
                <span> No log details to display </span>
            )}

        </div>
    );
};

const DetailItem = ({ label, oldValue, newValue }) => {
    function toTitleCase(str) {
        return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column' , margin: '0.3em'}}>
            <p
                style={{
                    fontWeight: 'bolder',
                }}
            >
                {toTitleCase(label)}:
            </p>
            <span style={{ display: 'flex', flexDirection: 'row' }}>
                <p style={{
                    marginLeft: '0.4em',
                    fontWeight: 'bold',
                    fontSize: '0.8em',
                    minWidth: '8%',
                }}
                >
                    Old Value:
                </p>
                <p style={{
                    marginLeft: '0.3em',
                    fontSize: '0.8em'
                }}>{oldValue}</p>
            </span>
            <span style={{ display: 'flex', flexDirection: 'row' }}>
                <p style={{
                    marginLeft: '0.4em',
                    fontWeight: 'bold',
                    fontSize: '0.8em',
                    minWidth: '8%',
                }}
                >
                    New Value:
                </p>
                <p style={{
                    marginLeft: '0.3em',
                    fontSize: '0.8em'
                }}>{newValue}</p>
            </span>
        </div>
    );
};
